import React, { useLayoutEffect, useState, useContext } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import AddBtn from 'components/AddBtn';
import DynamicPageContext from 'context/DynamicPage';
import { DataFormProps, Storie } from 'types/InputsStoriesCarouselProps';
import FormAddStorie from 'components/FormAddStorie';

interface AddStoriesInListProps {
	isShow: boolean;
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
}

export default function AddStoriesInList({
	isShow,
	setDataForm
}: AddStoriesInListProps) {
	const { moduleInSavingMode, moduleOnPhoneToEdit } =
		useContext(DynamicPageContext);
	const [isFormBannerOpen, setIsFormBannerOpen] = useState(false);
	const [listStorie, setListStorie] = useState<Storie[]>([]);
	const [storieToEdit, setStorieToEdit] = useState<Storie | null>(null);

	function addNewStorie(storie: Storie) {
		const newStorie: Storie = {
			idFront: storie.idFront,
			image: {
				id: storie.image.id || '',
				path: storie.image?.path || ''
			},
			redirect: {
				type: storie.redirect.type,
				value: storie.redirect.value
			},
			title: storie.title,
			query: storie.query
		};
		setListStorie((obj) => [...obj, newStorie]);
		setIsFormBannerOpen(false);
	}

	function editStorie(storieEdited: Storie) {
		const newList = listStorie.map((item) => {
			if (item.idFront === storieToEdit?.idFront) {
				const newBanner: Storie = {
					idFront: storieEdited.idFront,
					image: {
						id: storieEdited.image.id || '',
						path: storieEdited.image.path || ''
					},
					redirect: {
						type: storieEdited.redirect.type,
						value: storieEdited.redirect.value
					},
					title: storieEdited.title,
					query: storieEdited.query
				};
				return newBanner;
			}

			return item;
		});
		setListStorie(newList);
		setIsFormBannerOpen(false);
		setStorieToEdit(null);
	}

	function deleteBanner(id: string | number) {
		const newList = listStorie.filter((item) => item.idFront !== id);
		setListStorie(newList);
	}

	useLayoutEffect(() => {
		const newList = listStorie.map((item) => {
			return item;
		});

		setDataForm((obj) => ({ ...obj, stories: newList }));
	}, [listStorie]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setListStorie(moduleOnPhoneToEdit?.data?.stories || []);
			}, 100);
		}
	}, []);

	return (
		<S.container $isShow={isShow}>
			<AddBtn
				text="Adicionar Storie"
				anyFunction={() => setIsFormBannerOpen(true)}
			/>
			<S.listBanner>
				{listStorie.length > 0 ? (
					listStorie.map((item) => (
						<S.banner key={item.image.id}>
							<img src={`${item.image.path}`} />

							<S.content>
								<p>
									<b>Tipo de redirecionamento:</b> {item.redirect.type}
								</p>
								<p>
									<b>Valor redirecionamento </b> : {item.redirect.value}
								</p>

								<p>
									<b>Título</b> : {item.title}
								</p>
							</S.content>

							<S.actions>
								<MdDelete
									onClick={() => deleteBanner(item?.idFront || '')}
									color={color.system.error}
								/>
								<MdEdit
									onClick={() => {
										setStorieToEdit(item);
										setIsFormBannerOpen(true);
									}}
									color={color.interface.darkgray3}
								/>
							</S.actions>
						</S.banner>
					))
				) : (
					<S.noBanner>
						<p>Não há stories cadastrado</p>
					</S.noBanner>
				)}
			</S.listBanner>

			<FormAddStorie
				withTitle
				isOpen={isFormBannerOpen}
				setIsOpen={(value) => {
					setIsFormBannerOpen(value);
					setStorieToEdit(null);
				}}
				storieToEdit={storieToEdit}
				functionToGetDataAboutBanner={
					storieToEdit === null ? addNewStorie : editStorie
				}
			/>
		</S.container>
	);
}
